<div class="ch-progress-bar">
  <div
    class="ch-progress"
    [style.width.%]="percentage"
  ></div>
</div>